(() => {
  const items = {
    'parfums gourmands': {
      hash: 'gourmands',
      aliases: ['parfums gourmands', 'fragrances gourmandes', 'fragrance gourmande', 'gourmands', 'gourmandes']
    },
    'parfums fruites': {
      hash: 'fruites',
      aliases: ['parfums fruites', 'fragrances fruitees', 'fragrance fruitee', 'fruites', 'fruitees']
    },
    'parfums fleuris': {
      hash: 'fleuris',
      aliases: ['parfums fleuris', 'fragrances fleuries', 'fragrance fleurie', 'fleuris', 'fleuries']
    },
    'parfums boises': {
      hash: 'boises',
      aliases: ['parfums boises', 'fragrances boisees', 'fragrance boisee', 'boises', 'boisees']
    },
    'parfums frais': {
      hash: 'frais',
      aliases: ['parfums frais', 'fragrances fraiches', 'fragrance fraiche', 'frais', 'fraiches']
    }
  };

  const normalize = (value = '') => value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  const isVisible = (el) => {
    const rect = el.getBoundingClientRect();
    const style = window.getComputedStyle(el);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  };

  const findTarget = (item, minY) => {
    const aliases = item.aliases.map(normalize);
    const selectors = 'h1,h2,h3,h4,h5,h6,[class*="heading"],[class*="Heading"],[class*="title"],[class*="Title"],p,span,div';
    const candidates = Array.from(document.querySelectorAll(selectors))
      .filter(isVisible)
      .map((el) => ({
        el,
        text: normalize(el.textContent),
        top: el.getBoundingClientRect().top + window.scrollY
      }))
      .filter(({ text, top }) => top > minY && text && text.length <= 100);

    let matches = candidates.filter(({ text }) => aliases.includes(text));

    if (!matches.length) {
      matches = candidates.filter(({ text }) =>
        aliases.some((alias) => alias.length >= 5 && (text.startsWith(alias) || text.endsWith(alias)))
      );
    }

    matches.sort((a, b) => a.top - b.top);
    return matches.length ? matches[0].el : null;
  };

  const scrollToItem = (item, sourceEl) => {
    const sourceBottom = sourceEl
      ? sourceEl.getBoundingClientRect().bottom + window.scrollY
      : 0;
    const target = findTarget(item, sourceBottom + 40);
    if (!target) return false;

    const header = document.querySelector('header, .header, [data-header]');
    const headerHeight = header ? Math.min(header.getBoundingClientRect().height, 160) : 0;
    const offset = Math.max(24, headerHeight + 18);
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top, behavior: 'smooth' });
    history.replaceState(null, '', '#' + item.hash);
    return true;
  };

  document.addEventListener('click', (event) => {
    const clickable = event.target.closest('a,button,[role="button"],[role="tab"],[data-target-id]') || event.target;
    const key = normalize(clickable.textContent);
    const item = items[key];
    if (!item) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    scrollToItem(item, clickable);
  }, true);

  const scrollFromHash = () => {
    const hash = normalize(location.hash.replace('#', ''));
    const item = Object.values(items).find((entry) => entry.hash === hash);
    if (!item) return;

    setTimeout(() => {
      const target = findTarget(item, 0);
      if (!target) return;
      const header = document.querySelector('header, .header, [data-header]');
      const headerHeight = header ? Math.min(header.getBoundingClientRect().height, 160) : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - Math.max(24, headerHeight + 18);
      window.scrollTo({ top, behavior: 'smooth' });
    }, 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollFromHash, { once: true });
  } else {
    scrollFromHash();
  }
})();